import { Modal, ProgressBar, Button } from 'react-bootstrap';

const clampProgress = (value) => {
  if (typeof value !== 'number' || Number.isNaN(value)) return 0;
  if (value < 0) return 0;
  if (value > 100) return 100;
  return Math.round(value);
};

const formatBytes = (bytes) => {
  if (!bytes || typeof bytes !== 'number' || bytes <= 0) {
    return '0 B';
  }
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  let value = bytes;
  let unitIndex = 0;
  while (value >= 1024 && unitIndex < units.length - 1) {
    value /= 1024;
    unitIndex += 1;
  }
  const digits = value >= 100 || unitIndex === 0 ? 0 : value >= 10 ? 1 : 2;
  return `${value.toFixed(digits)} ${units[unitIndex]}`;
};

const UploadProgressModal = ({
  show,
  progress,
  currentFile,
  uploadedBytes,
  totalBytes,
  onCancel,
}) => {
  const normalizedProgress = clampProgress(progress);
  const showTotals = typeof totalBytes === 'number' && totalBytes > 0;
  const uploadedSummary = showTotals
    ? `${formatBytes(uploadedBytes)} of ${formatBytes(totalBytes)}`
    : null;

  return (
    <Modal show={show} onHide={() => {}} backdrop="static" centered keyboard={false}>
      <Modal.Header>
        <Modal.Title>Uploading files</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-8">
          {currentFile ? `Uploading ${currentFile}` : 'Preparing upload...'}
        </p>
        <ProgressBar now={normalizedProgress} label={`${normalizedProgress}%`} animated striped />
        {uploadedSummary && (
          <div className="mt-12 text-muted small">{uploadedSummary}</div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onCancel}>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default UploadProgressModal;
